
import axios from 'axios';
import React, { createContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import uuid from 'react-uuid';
import { ENDPOINT, getJWT, getOutletSessionId } from '../helpers/Helper';

export const AuthContext = createContext();

function AuthContextProvider(props) {
    const navigate = useNavigate();

    const [authState, setAuthState] = useState();
    const [userData, setUserData] = useState({});
    const [changePassword, setChangePassword] = useState(true);
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [authType, setAuthType] = useState('sign-in')

    useEffect(() => {
        const jwt = getJWT();
        const sessionId = getOutletSessionId();

        if (sessionId === null) {
            console.log('Hello');
            localStorage.setItem('THE_OUTLET_SESSION_ID', uuid())
            
        }

        if (jwt !== undefined || null) {
            setAuthState(jwt);

            axios.get(`${ENDPOINT}/auth/profile`, { headers: { Authorization: `Bearer ${jwt}`}})
                .then(res => {
                    setUserData(res.data);
                })
                .catch (err => {
                    localStorage.removeItem('JWT_TOKEN_OUTLET');
                    setAuthState();
                })
        } 

    }, [getJWT()])

    const handleFirstChangePassword = (currentPassword, newPassword, confirmNewPassword) => {
        const data = {
            "currentPassword": currentPassword,
            "newPassword": newPassword
        }

        const jwt = getJWT();

        if (newPassword === confirmNewPassword){
            axios.post(`${ENDPOINT}/auth/change-password`, data, { headers: { Authorization: `Bearer ${jwt}`}})
                .then(res => {
                    setChangePassword(true);
                })
                .catch(err => {
                    alert(err.response.data.error)
                })
        }        
    }

    const handleLogOut = () => {
        localStorage.removeItem('JWT_TOKEN_OUTLET');
        setAuthState();
        navigate("/")
    }
    const handleShowAuthModal = () => {
        setShowAuthModal(true)
    }

    const handleOnCloseAuthModal = () => {
        setShowAuthModal(!showAuthModal);
        setAuthType('sign-in')
    }

    const handleSignInModal = () => {
        setAuthType('sign-in');
    }

    const handleSignUpModal = () => {
        setAuthType('sign-up')
    }

    const handleForgotPasswordModal = () => {
        setAuthType('forgot-password')
    }

    const handleSuccessfulForgotPasswordModal = () => {
        setAuthType('successful_forgot-password')
    }

    

    const handleSuccessfulSignUpModal = () => {
        setAuthType('successful_signup')
    }

    return (
        <AuthContext.Provider value={{ 
                authState, 
                authType,
                userData, 
                changePassword, 
                handleFirstChangePassword, 
                handleLogOut, 
                showAuthModal, 
                handleShowAuthModal,
                handleOnCloseAuthModal, 
                handleSignInModal, 
                handleSignUpModal, 
                handleForgotPasswordModal, 
                handleSuccessfulSignUpModal ,
                handleSuccessfulForgotPasswordModal
            }}
        >
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthContextProvider